import { render } from "./CadastroContratoTransportador.vue?vue&type=template&id=6b3d3cf9"
import script from "./CadastroContratoTransportador.vue?vue&type=script&lang=ts"
export * from "./CadastroContratoTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script